/** @format */

import PercentageContainer from "./Containers/PercentageContainer";
export default PercentageContainer;
